import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.5 6.5a2 2 0 012 2v12h0-19l17-3V4m-19 2l15.75-4.07a1 1 0 011.25.968V11.5h0l-4 4-11.74 3.16a1 1 0 01-1.26-.965V6h0zm13 9.5v-4h4" stroke="currentColor" fill="none" /></svg>;